import { DAYHLIST } from "../actions/dailyHistory";

import { reducerPackage } from "../../utils";

export const dailyHistoryList = reducerPackage(DAYHLIST);
